<template>
  <div class="pesquisa-clientes">
    <div style="z-index: 1050" aria-hidden="true" class="modal-backdrop fade show"></div>
    <div role="dialog" tabindex="-1" class="modal fade show d-block" aria-modal="true">
      <div role="document" class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <font-awesome-icon :icon="['fas', 'users']" fixed-width/>
              Localizar cliente
            </h5>
            <button type="button" v-on:click="fechaModal()" class="btn-close" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="input-group">
                  <input autofocus="" class="form-control form-control" name="searchFor" placeholder="Procurar" type="text">
                  <button v-on:click="handlePesquisa" class="btn btn btn-outline-primary" type="button">
                    <font-awesome-icon :icon="['fas', 'search']" fixed-width/>
                  </button>
                </div>
              </div>
              <div class="col-12 mt-2">
                <table class="table table-bordered table-sm table-striped table-hover">
                  <thead class="thead-light">
                    <tr>
                      <th>Razão social</th>
                      <th class="d-none d-lg-table-cell">Endereço</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cliente in listaClientes"
                        :key="cliente.id"
                        v-on:click="preSelecionaCliente(cliente)"
                        class="my-sm cursor-pointer">
                      <td scope="row">
                        <i class="fa text-secondary mr-1 fa-user"></i>
                        {{cliente.razao_social}}
                      </td>
                      <td class="d-none d-lg-table-cell">-</td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group">
                  <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
                </div>
              </div>
            </div>

            <hr class="m-0">
            <div v-if="(!!preSelecionado)" class="row small ng-star-inserted">
              <div class="col-12">
                <p class="text-secondary mb-0"><strong style="font-size: 16px;">Dados do cliente selecionado</strong></p>
                <span class="text-secondary">
                  <strong style="font-size: 14px;">{{preSelecionado.razao_social}}</strong>
                </span>
              </div>
              <div class="col-md-auto mr-4">
                <i class="fa fa-address-card fa-fw"></i> -
              </div>
              <div class="col-auto mr-4">
                <i class="fa fa-phone fa-fw"></i> {{preSelecionado.telefone}}
              </div>
              <div class="col-auto mr-4 d-none">
                <i class="fa fa-dollar-sign fa-fw"></i> Limite disp.: R$ 0,00
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-on:click="fechaModal()" class="btn btn-outline-secondary" type="button">
              <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
              Cancelar
            </button>
            <button v-on:click="selecionaCliente" v-bind:disabled="!podeSelecionarCliente" class="btn btn-success" type="button">
              <font-awesome-icon :icon="['fas', 'check']" fixed-width/>
              Selecionar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'PesquisaClientes',
  components: {
    Paginador,
  },
  data() {
    return {
      preSelecionado: undefined,
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaClientes: [],
    }
  },
  methods: {
    fechaModal() {
      this.$emit('modal-pesquisa-cliente-resultado', undefined);
    },

    handlePesquisa() {
      this.preSelecionado = undefined;
      loading(true);

      api.get(`/clientes?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaClientes = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;

        //TODO: REMOVER ADIANTAMENTO
        /*
        this.preSelecionaCliente(this.listaClientes[0]);
        setTimeout(() => {
          this.selecionaCliente();
        }, 300);
        */

      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    preSelecionaCliente(cliente) {
      this.preSelecionado = cliente;
    },

    selecionaCliente() {
      const clienteSelecionado = clone(this.preSelecionado);
      this.$emit('modal-pesquisa-cliente-resultado', clienteSelecionado);
    },
  },
  computed: {
    podeSelecionarCliente() {
      return (!!this.preSelecionado);
    }
  },
  mounted() {
    this.handlePesquisa();
  }
}
</script>

<style>
</style>
